// src/pages/ApplicationChampionshipSeason/shared/steps/Step2Stages/AddStageButton.tsx
import { FunctionComponent } from 'react';
import { Button } from '@chakra-ui/react';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

type AddStageButtonProps = {
  label: string;
  onClick: () => void;
};

export const AddStageButton: FunctionComponent<AddStageButtonProps> = ({
  label,
  onClick,
}) => (
  <Button
    variant="outline"
    color="gray.600"
    size="sm"
    alignSelf="flex-start"
    leftIcon={<ChakraFeatherIcon name="plus" boxSize="16px" />}
    onClick={onClick}
  >
    {label}
  </Button>
);
